(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9412,7126],{

/***/ 95821:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mail",
      function () {
        return __webpack_require__(15556);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landing_pages_v2_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/text.mjs
var components_text = __webpack_require__(9225);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODThemeLite.mjs
var ODThemeLite = __webpack_require__(69666);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/cms/index.ts + 1 modules
var cms = __webpack_require__(96887);
// EXTERNAL MODULE: ./src/cms/utils.ts
var utils = __webpack_require__(46000);
;// CONCATENATED MODULE: ./src/cms/navHeaderUtils.ts


function extractNavData(header) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var mainNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref = header.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.mainNav) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(link) {
        // mainNav can now be ILpElementLink (simple) or ILpElementSimpleList (with sections)
        // Only extract simple links for mainNavLinks
        if (!(0,utils/* isSimpleLink */.$)(link)) return;
        if (!link.fields.text || !link.fields.url) return;
        mainNavLinks.push({
            name: link.fields.text,
            href: link.fields.url
        });
    });
    var menuPanelNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref2 = header.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.menuPanelNav) === null || ref3 === void 0 ? void 0 : ref3.forEach(function(link) {
        if (link.fields.text && link.fields.url) {
            menuPanelNavLinks.push({
                name: link.fields.text,
                href: link.fields.url
            });
        }
    });
    var ctaTitle = header === null || header === void 0 ? void 0 : header.fields.menuPanelCtaTitle;
    var ctaLink;
    if ((header === null || header === void 0 ? void 0 : (ref4 = header.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.menuPanelCta) === null || ref5 === void 0 ? void 0 : ref5.fields.text) && (header === null || header === void 0 ? void 0 : (ref6 = header.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.menuPanelCta) === null || ref7 === void 0 ? void 0 : ref7.fields.url)) {
        ctaLink = {
            name: header.fields.menuPanelCta.fields.text,
            href: header.fields.menuPanelCta.fields.url
        };
    }
    // Transform header.mainNav (union type) into MegaNavItem[] format
    var megaNavData = (0,cms/* transformHeaderNavToMegaNav */.$C)(header === null || header === void 0 ? void 0 : (ref8 = header.fields) === null || ref8 === void 0 ? void 0 : ref8.mainNav);
    return {
        mainNavLinks: mainNavLinks,
        menuPanelNavLinks: menuPanelNavLinks,
        megaNavData: megaNavData,
        ctaTitle: ctaTitle,
        ctaLink: ctaLink
    };
}

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(54991);
// EXTERNAL MODULE: ./src/helpers/queryParams.ts
var queryParams = __webpack_require__(43552);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/InspectionBanner.tsx
"use client";



var GiftIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18.5 21H5.5V12H3.5V8H20.5V12H18.5V21Z",
                fill: "url(#paint0_linear_4031_637)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M12 8V21M12 8C11.6383 6.5094 11.0154 5.23501 10.2127 4.34311C9.41003 3.45121 8.46469 2.98314 7.5 2.99995C6.83696 2.99995 6.20107 3.26334 5.73223 3.73218C5.26339 4.20102 5 4.83691 5 5.49995C5 6.16299 5.26339 6.79887 5.73223 7.26772C6.20107 7.73656 6.83696 7.99995 7.5 7.99995M12 8C12.3617 6.5094 12.9846 5.23501 13.7873 4.34311C14.59 3.45121 15.5353 2.98314 16.5 2.99995C17.163 2.99995 17.7989 3.26334 18.2678 3.73218C18.7366 4.20102 19 4.83691 19 5.49995C19 6.16299 18.7366 6.79887 18.2678 7.26772C17.7989 7.73656 17.163 7.99995 16.5 7.99995M19 12V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V12M3 9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V11C21 11.2652 20.8946 11.5196 20.7071 11.7071C20.5196 11.8946 20.2652 12 20 12H4C3.73478 12 3.48043 11.8946 3.29289 11.7071C3.10536 11.5196 3 11.2652 3 11V9Z",
                stroke: "#F9C940",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "paint0_linear_4031_637",
                    x1: "16",
                    y1: "9",
                    x2: "12",
                    y2: "21",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            stopColor: "#A51C1C"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "1",
                            stopColor: "#E12020"
                        })
                    ]
                })
            })
        ]
    });
};
var BANNER_DISMISSED_KEY = "inspection-banner-dismissed";
/**
 * Promotional banner for free home inspection report offer.
 * Part of experiment: growth-25-12-inspection-banner
 *
 * Impression tracking is handled at the Cloudflare Worker level.
 *
 * Figma: https://www.figma.com/design/PRkjHWTpRlrz6YFlekrChg/?node-id=4002-2104
 */ var InspectionBanner = function() {
    var ref = (0,react.useState)(true), isDismissed = ref[0], setIsDismissed = ref[1]; // Start hidden to prevent flash
    (0,react.useEffect)(function() {
        // Check localStorage on mount
        var dismissed = localStorage.getItem(BANNER_DISMISSED_KEY) === "true";
        setIsDismissed(dismissed);
    }, []);
    var handleDismiss = function() {
        setIsDismissed(true);
        localStorage.setItem(BANNER_DISMISSED_KEY, "true");
    };
    if (isDismissed) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        id: "inspection-banner",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: "$3x",
        paddingHorizontal: "$4x",
        gap: "$3x",
        // Figma: #00278b (sem/color/background/state/hover/accent-brand)
        style: {
            backgroundColor: "#00278b"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                $largerThanSM: {
                    justifyContent: "center"
                },
                gap: "$2x",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexShrink: 0,
                        display: "flex",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GiftIcon, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "white",
                        textAlign: "left",
                        $largerThanSM: {
                            textAlign: "center"
                        },
                        children: [
                            "Get a",
                            " ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                fontWeight: "$medium",
                                color: "white",
                                children: "FREE home inspection report"
                            }),
                            " ",
                            "($450 value) with your Opendoor offer"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                flexShrink: 0,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* CloseButton */.PZ, {
                    analyticsName: "cosmos-inspection-banner-close",
                    onPress: handleDismiss,
                    size: "small",
                    variant: "inverse"
                })
            })
        ]
    });
};
/* harmony default export */ var landing_pages_v2_InspectionBanner = (InspectionBanner);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 25 modules
var Header = __webpack_require__(8268);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/useInspectionBannerExperiment.ts


var INSPECTION_BANNER_EXPERIMENT_KEY = "growth-25-12-inspection-banner";
/**
 * LocalStorage key for storing the experiment variant.
 * This allows us to pass the variant to the backend when creating a seller input
 * so it can be stored on the lead for Iterable attribution.
 */ var INSPECTION_BANNER_VARIANT_STORAGE_KEY = "inspection-banner-experiment-variant";
/**
 * Get the stored inspection banner experiment variant from localStorage.
 * This can be used when creating a seller input to pass the variant to the backend
 * for Iterable attribution tracking.
 */ function getStoredInspectionBannerVariant() {
    if (false) {}
    var stored = localStorage.getItem(INSPECTION_BANNER_VARIANT_STORAGE_KEY);
    if (stored === "treatment" || stored === "control") {
        return stored;
    }
    return null;
}
/**
 * Hook to get the inspection banner experiment variant from query params.
 * Returns 'treatment' to show the banner, 'control' for no banner,
 * or null while loading.
 *
 * The variant is bucketed at the Cloudflare Worker level using Amplitude local evaluation
 * and passed to Cosmos via the `inspection_banner_variant` query param.
 * Impression tracking is handled automatically by the CF Worker.
 *
 * The variant is also stored in localStorage so it can be passed to the backend
 * when creating a seller input for Iterable attribution tracking.
 */ function useInspectionBannerExperiment() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), variant = ref[0], setVariant = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react.useEffect)(function() {
        // Wait for router to be ready (query params populated)
        if (!router.isReady) {
            return;
        }
        // Read variant from query param (set by Cloudflare Worker)
        var queryVariant = router.query.inspection_banner_variant;
        var resolvedVariant = queryVariant === "treatment" ? "treatment" : "control";
        setVariant(resolvedVariant);
        setIsLoading(false);
        // Store variant in localStorage for backend attribution
        localStorage.setItem(INSPECTION_BANNER_VARIANT_STORAGE_KEY, resolvedVariant);
    }, [
        router.isReady,
        router.query.inspection_banner_variant
    ]);
    return {
        variant: variant,
        isLoading: isLoading
    };
}

// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/index.js + 7 modules
var Dialog = __webpack_require__(60179);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/VisitorModal.tsx




var GetCashOfferModal = function(entry) {
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        var timer;
        if (authentication.state === "not_authenticated") {
            var hasShownDialog = localStorage.getItem("getCashOfferModalShown");
            if (!hasShownDialog) {
                timer = setTimeout(function() {
                    setIsOpen(true);
                    localStorage.setItem("getCashOfferModalShown", "true");
                }, 400);
            }
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        authentication.state
    ]);
    var handleClose = function() {
        setIsOpen(!isOpen);
    };
    var analyticsName = "cosmos-landing-page-visitor-modal-".concat(entry === null || entry === void 0 ? void 0 : entry.analyticsId);
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
        isOpen: isOpen,
        dismissable: largerThanSM ? true : false,
        animation: "accelerateDecelerateFast",
        setIsOpen: handleClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            maxWidth: 504,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                title: entry.title,
                titleProps: {
                    typography: "$subheaderLarge",
                    $largerThanSM: {
                        typography: "$headerLarge"
                    }
                },
                description: entry.description,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    $largerThanSM: {
                        pt: "$24x"
                    },
                    pt: "$16x",
                    children: [
                        !largerThanSM && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            variant: "secondary",
                            size: "small",
                            analyticsName: analyticsName,
                            label: "Close",
                            onPress: handleClose
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            marginTop: "$4x",
                            variant: "primary",
                            size: "small",
                            $largerThanSM: {
                                size: "medium"
                            },
                            onPress: function() {
                                document.location.href = "https://www.opendoor.com/address-entry";
                            },
                            analyticsName: "".concat(analyticsName, "-cash-offer-cta"),
                            label: "Get a cash offer"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var VisitorModal = (GetCashOfferModal);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/Layout.tsx















var MaintenanceBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 716).then(__webpack_require__.bind(__webpack_require__, 40716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40716)
            ];
        }
    }
});
var Footer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1243).then(__webpack_require__.bind(__webpack_require__, 71243));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71243)
            ];
        }
    }
});
var Layout = function(param) {
    var header = param.header, slug = param.slug, footer = param.footer, extraLegalText = param.extraLegalText, showEligibilityLegal = param.showEligibilityLegal, showCustomerTestimonialLegal = param.showCustomerTestimonialLegal, showThePdpCopyrightLegal = param.showThePdpCopyrightLegal, showPromotionLegal = param.showPromotionLegal, children = param.children, showModal = param.showModal, modalTitle = param.modalTitle, modalDescription = param.modalDescription, modalAnalyticsId = param.modalAnalyticsId, hideHeader = param.hideHeader, hideFooter = param.hideFooter;
    var ref = useInspectionBannerExperiment(), inspectionBannerVariant = ref.variant;
    // Only show inspection banner on homepage variants for treatment group
    // Matches: '/', '/homepage-kt', '/homepage-v2', '/landing-pages-v2/homepage-kt', etc.
    var isHomepage = slug === "/" || slug.toLowerCase().includes("homepage");
    var showInspectionBanner = isHomepage && inspectionBannerVariant === "treatment";
    var navData = extractNavData(header);
    var mainNavLinks = navData.mainNavLinks, menuPanelNavLinks = navData.menuPanelNavLinks, megaNavData = navData.megaNavData, ctaTitle = navData.ctaTitle, ctaLink = navData.ctaLink;
    var getOfferExperiment = (0,queryParams/* default */.Z)().getOfferExperiment;
    var showGetCashOfferModal = showModal && getOfferExperiment === "treatment";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ODThemeLite/* ThemedLite */.h, {
        baseTheme: "novo",
        team: "growth",
        launchDateString: new Date().toISOString(),
        // NOTE: This is a hack to fix responsive sizing due to issues in the feature's figma designs
        // TODO(@product-growth): Remove this when the design system is updated
        overrides: {
            components: {
                Text: {
                    sizes: UpdatedTextSizing
                },
                Heading: {
                    sizes: UpdatedTextSizing
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-regular/Graphik-Regular.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-medium/Graphik-Medium.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-semibold/Graphik-Semibold.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-bold/Graphik-Bold.woff2",
                        as: "font"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaintenanceBanner, {}),
            showInspectionBanner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landing_pages_v2_InspectionBanner, {}),
            showGetCashOfferModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VisitorModal, {
                title: modalTitle,
                description: modalDescription,
                analyticsId: modalAnalyticsId
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                position: "relative",
                display: "block",
                children: [
                    !hideHeader && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                        menuPanelNavLinks: menuPanelNavLinks,
                        mainNavLinks: mainNavLinks,
                        ctaTitle: ctaTitle,
                        ctaLink: ctaLink,
                        slug: slug,
                        megaNavData: megaNavData
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            width: "100%",
                            margin: 0,
                            display: "block",
                            children: [
                                children,
                                !hideFooter && footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {
                                    siteFooter: footer,
                                    extraLegalText: extraLegalText,
                                    showCustomerTestimonialLegal: showCustomerTestimonialLegal,
                                    showEligibilityLegal: showEligibilityLegal,
                                    showPromotionLegal: showPromotionLegal,
                                    showThePdpCopyrightLegal: showThePdpCopyrightLegal
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/**
 * All the following typography overrides are for the 2023 Homepage Reskin project
 * https://www.figma.com/file/g2qLawddmhROv347l6EF7m/HP-Reskin?type=design&node-id=325-28241&mode=design&t=5CA6uSlmM7nuVuIC-0
 * TODO: re-assess overrides after experiment is over
 *
 * NOTE: This object gets deep merged w/ the novo theme so we only need to define the differences
 */ var UpdatedTextSizing = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, components_text/* sizes */.J), {
    100: {
        fontSize: [
            "14px",
            null,
            null,
            "18px"
        ],
        lineHeight: "140",
        letterSpacing: "-1.4"
    },
    // Used in FAQsDisplay, VideoHero, ReviewCard, MenuPanel
    110: {
        fontSize: [
            "16px",
            null,
            "14px",
            "16px"
        ],
        lineHeight: [
            "25.6px",
            null,
            "25.6px",
            "160%"
        ],
        letterSpacing: [
            "-1.4%",
            "-0.014em",
            "-0.014em",
            "-0.018em"
        ]
    },
    // Used in Hero, ReviewCard
    120: {
        fontSize: "18px",
        lineHeight: "120",
        letterSpacing: "-2.4"
    },
    // Used in StickyCTAUtility
    130: {
        fontSize: [
            "16px",
            null,
            "19px"
        ],
        lineHeight: "19px",
        letterSpacing: "-2.4"
    },
    // Used in Footer, Hero
    140: {
        fontSize: "22px",
        lineHeight: "112",
        letterSpacing: "-2.4"
    },
    // Used in FAQsDisplay, MapBackgroundHero, Steps, Testimonials, TextSection
    150: {
        fontSize: [
            "16px",
            null,
            null,
            "24px"
        ],
        lineHeight: [
            "130%",
            null,
            null,
            "112%"
        ],
        letterSpacing: [
            "-0.014em",
            null,
            null,
            "-0.028em"
        ]
    },
    // Used in HeroCard, VideoHero
    160: {
        fontSize: [
            "18px",
            "19px",
            null,
            "28px"
        ],
        lineHeight: [
            "120%",
            null,
            null,
            "110%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.02em",
            "-0.028em",
            "-0.028em"
        ]
    },
    // Used in CarouselCards, Footer
    170: {
        fontSize: [
            "32px",
            "36px",
            "44px",
            "56px"
        ],
        lineHeight: [
            "35.2px",
            "36px",
            "44px",
            "56px"
        ],
        letterSpacing: [
            "-2.8",
            "-3",
            "-3.4"
        ],
        fontWeight: 500
    },
    // Used in ImageCard
    180: {
        fontSize: [
            "16px",
            "18px",
            null,
            "28px"
        ],
        lineHeight: [
            "120%",
            null,
            null,
            "110%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.02em",
            "-0.028em",
            "-0.028em"
        ]
    },
    // Used in HeroCard, ImageCard
    220: {
        fontSize: [
            "22.2px",
            "28px",
            "36px",
            "56px"
        ],
        lineHeight: [
            "106%",
            "110%",
            "100%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.028em",
            "-0.03em",
            "-0.034em;"
        ]
    },
    // Used in FAQsDisplay, MapBackgroundHero, TextSection
    230: {
        fontSize: [
            "32px",
            "36px",
            "44px",
            "64px"
        ],
        lineHeight: [
            "110%",
            "100%"
        ],
        letterSpacing: [
            "-0.028em",
            "-0.03em",
            "-0.03em",
            "-0.034em;"
        ]
    },
    240: {
        fontSize: [
            "36px",
            null,
            "80px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    },
    250: {
        fontSize: [
            "44px",
            null,
            "88px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    },
    260: {
        fontSize: [
            "60px",
            null,
            "96px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    }
});
/* harmony default export */ var landing_pages_v2_Layout = (Layout);


/***/ }),

/***/ 15556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ mail; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/Layout.tsx + 4 modules
var Layout = __webpack_require__(47126);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/api.mjs
var api = __webpack_require__(82293);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./src/components/api/index.ts + 2 modules
var components_api = __webpack_require__(67945);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./src/components/shared/NewAddressInput.tsx
var NewAddressInput = __webpack_require__(98066);
;// CONCATENATED MODULE: ./src/components/mail/AddressEntryPage.tsx







var AddressEntryPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AddressEntryPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(AddressEntryPage);
    function AddressEntryPage() {
        (0,_class_call_check/* default */.Z)(this, AddressEntryPage);
        return _super.apply(this, arguments);
    }
    var _proto = AddressEntryPage.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            gap: "$10x",
            padding: "$10x",
            $smallerThanMD: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h1",
                    textAlign: "center",
                    $largerThanSM: {
                        textAlign: "left",
                        typography: "$subheaderXsmall"
                    },
                    typography: "$subheaderSmall",
                    children: "Unsubscribe from mail"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h3",
                    textAlign: "center",
                    $largerThanSM: {
                        textAlign: "left",
                        typography: "$bodyMedium"
                    },
                    typography: "$bodySmall",
                    children: "Please enter the address where you would no longer like to receive mail from Opendoor."
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewAddressInput/* default */.Z, {
                    onChooseManualEntry: this.props.onChooseManualEntry,
                    onSubmit: this.props.onSubmit,
                    showCta: true,
                    // @ts-expect-error: Type mismatch caused by withRouter's inability to infer the correct variant of IProps (either AddressInputProps or AddressInputWithCtaProps).
                    // We know that ctaProps will be conditionally passed
                    ctaProps: {
                        actionText: "Unsubscribe",
                        "aria-label": ""
                    }
                })
            ]
        });
    };
    return AddressEntryPage;
}(react.PureComponent);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box_Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Heading/Heading.mjs
var Heading = __webpack_require__(37982);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text_Text = __webpack_require__(4796);
;// CONCATENATED MODULE: ./src/components/mail/ErrorPage.tsx






var ErrorPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(ErrorPage);
    function ErrorPage() {
        (0,_class_call_check/* default */.Z)(this, ErrorPage);
        return _super.apply(this, arguments);
    }
    var _proto = ErrorPage.prototype;
    _proto.render = function render() {
        var casaAddress = this.props.casaAddress;
        var unit = casaAddress && casaAddress.unitNumber && casaAddress.unitNumber ? casaAddress.unitType + " " + casaAddress.unitNumber : null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* default */.Z, {
            maxWidth: "600px",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H3, {
                    width: "100%",
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text_Text/* default */.Z, {
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: [
                        "There was a problem unsubscribing ",
                        casaAddress ? casaAddress.street : "your home",
                        unit && ", ".concat(unit),
                        " from our mailing list. Please email your full address to mail@opendoor.com to unsubscribe."
                    ]
                })
            ]
        });
    };
    return ErrorPage;
}(react.PureComponent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Button/Button.mjs
var Button = __webpack_require__(26029);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Input/Input.mjs + 2 modules
var Input = __webpack_require__(245);
;// CONCATENATED MODULE: ./src/components/mail/ManualAddressPage.tsx










var ManualAddressPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ManualAddressPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(ManualAddressPage);
    function ManualAddressPage() {
        (0,_class_call_check/* default */.Z)(this, ManualAddressPage);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            address: _this.props.addressInput || {},
            loadingSubmit: false
        };
        _this.handleOnChange = function(name, value) {
            var address = _this.state.address;
            _this.setState({
                address: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), (0,_define_property/* default */.Z)({}, name, value))
            });
        };
        _this.handleModifyAddress = function() {
            _this.setState({
                loadingSubmit: true
            });
            _this.props.modifyAddress(_this.state.address);
        };
        _this.handleCancel = function() {
            _this.props.cancelManualAddressVerification(!!_this.props.addressInput);
        };
        return _this;
    }
    var _proto = ManualAddressPage.prototype;
    _proto.render = function render() {
        var _this = this;
        var address = this.state.address;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* default */.Z, {
            flex: [
                "1 0 auto",
                null,
                "0 1 auto"
            ],
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H3, {
                    width: "100%",
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: "What’s your address?"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    flexDirection: "column",
                    width: "100%",
                    mb: 7,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                            flexDirection: [
                                "column",
                                null,
                                "row"
                            ],
                            mb: 6,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                    flex: 2,
                                    mr: [
                                        null,
                                        null,
                                        4
                                    ],
                                    mb: [
                                        3,
                                        null,
                                        0
                                    ],
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                        analyticsName: "cosmos-manual-address-page-street",
                                        id: "street1",
                                        name: "street1",
                                        value: address.street1,
                                        onChange: function(_event, value) {
                                            return _this.handleOnChange("street1", value);
                                        },
                                        placeholder: "Street Address",
                                        "aria-label": "Street Address",
                                        type: "text",
                                        unboundedWidth: true
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                        analyticsName: "cosmos-manual-address-page-unit-number",
                                        id: "unit",
                                        name: "unit",
                                        value: address.unit,
                                        onChange: function(_event, value) {
                                            return _this.handleOnChange("unit", value);
                                        },
                                        placeholder: "Unit Number",
                                        "aria-label": "Unit Number",
                                        type: "text",
                                        unboundedWidth: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                            flexDirection: [
                                "column",
                                null,
                                "row"
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                    flexDirection: [
                                        "column",
                                        null,
                                        "row"
                                    ],
                                    flex: 2,
                                    mr: [
                                        null,
                                        null,
                                        4
                                    ],
                                    mb: [
                                        3,
                                        null,
                                        0
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                            flex: 2,
                                            mr: [
                                                null,
                                                null,
                                                4
                                            ],
                                            mb: [
                                                3,
                                                null,
                                                0
                                            ],
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                                analyticsName: "cosmos-manual-address-page-city",
                                                id: "city",
                                                name: "city",
                                                value: address.city,
                                                onChange: function(_event, value) {
                                                    return _this.handleOnChange("city", value);
                                                },
                                                placeholder: "City",
                                                "aria-label": "City",
                                                type: "text",
                                                unboundedWidth: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                            flex: 1,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                                analyticsName: "cosmos-manual-address-page-state",
                                                id: "state",
                                                name: "state",
                                                value: address.state,
                                                onChange: function(_event, value) {
                                                    return _this.handleOnChange("state", value);
                                                },
                                                placeholder: "State",
                                                "aria-label": "State",
                                                type: "text",
                                                unboundedWidth: true
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.ZP, {
                                        analyticsName: "cosmos-manual-address-page-postal-code",
                                        id: "postal_code",
                                        name: "postal_code",
                                        value: address.postal_code,
                                        onChange: function(_event, value) {
                                            return _this.handleOnChange("postal_code", value);
                                        },
                                        placeholder: "Postal Code",
                                        "aria-label": "Postal Code",
                                        type: "text",
                                        unboundedWidth: true
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                            onClick: this.handleModifyAddress,
                            disabled: !address.street1 || !address.city || !address.state || !address.postal_code,
                            mr: [
                                null,
                                null,
                                4
                            ],
                            mb: [
                                3,
                                null,
                                0
                            ],
                            loading: this.state.loadingSubmit,
                            "aria-label": "Submit modified address",
                            analyticsName: "cosmos-manual-address-page-submit-modified-address",
                            children: "Continue"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                            variant: "secondary",
                            onClick: this.handleCancel,
                            "aria-label": "Cancel address modification",
                            analyticsName: "cosmos-manual-address-page-cancel-address-modification",
                            children: "Cancel"
                        })
                    ]
                })
            ]
        });
    };
    return ManualAddressPage;
}(react.PureComponent);

;// CONCATENATED MODULE: ./src/components/mail/SuccessPage.tsx






var SuccessPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SuccessPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(SuccessPage);
    function SuccessPage() {
        (0,_class_call_check/* default */.Z)(this, SuccessPage);
        return _super.apply(this, arguments);
    }
    var _proto = SuccessPage.prototype;
    _proto.render = function render() {
        var casaAddress = this.props.casaAddress;
        var unit = casaAddress && casaAddress.unitNumber && casaAddress.unitNumber ? casaAddress.unitType + " " + casaAddress.unitNumber : null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* default */.Z, {
            maxWidth: "600px",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading.H3, {
                    width: "100%",
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: "You’ve successfully unsubscribed!"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text_Text/* default */.Z, {
                    textAlign: [
                        "center",
                        null,
                        "left"
                    ],
                    mb: 7,
                    children: [
                        "We’ve removed ",
                        casaAddress ? casaAddress.street : "your home",
                        unit && ", ".concat(unit),
                        " from our mailing list. You may receive one more piece of mail if it’s been processed before your unsubscribe which may arrive over the next 6-8 weeks."
                    ]
                })
            ]
        });
    };
    return SuccessPage;
}(react.PureComponent);

// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/growth/GoogleMapDisplay/index.mjs + 2 modules
var GoogleMapDisplay = __webpack_require__(32804);
;// CONCATENATED MODULE: ./src/components/mail/VerifyAddressPage.tsx







var VerifyAddressPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VerifyAddressPage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(VerifyAddressPage);
    function VerifyAddressPage() {
        (0,_class_call_check/* default */.Z)(this, VerifyAddressPage);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            loadingUnsubscribe: false
        };
        _this.handleUnsubscribe = function() {
            _this.setState({
                loadingUnsubscribe: true
            });
            _this.props.unsubscribeAddress();
        };
        return _this;
    }
    var _proto = VerifyAddressPage.prototype;
    _proto.render = function render() {
        var _props = this.props, casaAddress = _props.casaAddress, googleMapsApiKey = _props.googleMapsApiKey, googleMapsOptions = _props.googleMapsOptions;
        var center = {
            lat: casaAddress.latitude,
            lng: casaAddress.longitude
        };
        var unit = casaAddress.unitType + " " + casaAddress.unitNumber;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box_Box/* default */.Z, {
            flex: [
                "1 0 auto",
                null,
                "0 1 auto"
            ],
            minWidth: [
                "0px",
                null,
                "600px"
            ],
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box/* default */.Z, {
                    mb: 8,
                    width: "100%",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoogleMapDisplay/* GoogleMapDisplay */.p, {
                        options: googleMapsOptions,
                        center: center,
                        googleMapsApiKey: googleMapsApiKey,
                        height: "300px"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text_Text/* default */.Z, {
                    fontSize: "s3",
                    fontWeight: "semibold",
                    mb: 6,
                    lineHeight: "s3",
                    children: [
                        casaAddress.street,
                        unit && ", ".concat(unit),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                        casaAddress.city,
                        ", ",
                        casaAddress.state,
                        " ",
                        casaAddress.postalCode
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text/* default */.Z, {
                    fontSize: "s1",
                    mb: 8,
                    children: "Is this the correct address?"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                            mr: [
                                null,
                                null,
                                4
                            ],
                            mb: [
                                3,
                                null,
                                0
                            ],
                            onClick: this.handleUnsubscribe,
                            loading: this.state.loadingUnsubscribe,
                            "aria-label": "Confirm address is correct",
                            analyticsName: "cosmos-verify-address-page-confirm-correct-address",
                            children: "Yes, that’s right"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.ZP, {
                            variant: "secondary",
                            onClick: this.props.toManualAddressVerification,
                            "aria-label": "",
                            analyticsName: "cosmos-verify-address-page-fix-address",
                            children: "Add unit # or fix address"
                        })
                    ]
                })
            ]
        });
    };
    return VerifyAddressPage;
}(react.PureComponent);

;// CONCATENATED MODULE: ./src/components/mail/UnsubscribePage.tsx















var Sentry = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient();
var UnsubscribePage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(UnsubscribePage, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(UnsubscribePage);
    function UnsubscribePage() {
        (0,_class_call_check/* default */.Z)(this, UnsubscribePage);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            casaAddress: null,
            pageType: "address-entry"
        };
        _this.submitAddress = function(address) {
            (0,api/* standardizeAddress */.ce)(address).then(function(response) {
                if (!response || !response.data || response.errors) {
                    _this.setState({
                        pageType: "manual"
                    });
                } else {
                    _this.setState({
                        casaAddress: _this.getCasaAddressData(response.data),
                        pageType: "verify"
                    });
                }
            });
        };
        _this.unsubscribeAddress = function(address) {
            if (address && address.addressUuid) {
                (0,components_api/* unsubscribeMailer */.Y)(address.addressUuid).then(function(response) {
                    if (!response || !response.data || response.errors) {
                        var ref;
                        _this.setState({
                            pageType: "error"
                        });
                        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, "Unsubscribe mailer request failed", {
                            captureContext: {
                                extra: {
                                    error: response.message
                                }
                            }
                        });
                    } else {
                        _this.setState({
                            pageType: "success"
                        });
                    }
                });
            } else {
                _this.setState({
                    pageType: "error"
                });
            }
        };
        _this.cancelManualAddressVerification = function(hasAddressInput) {
            _this.setState({
                pageType: hasAddressInput ? "verify" : "address-entry"
            });
        };
        return _this;
    }
    var _proto = UnsubscribePage.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
            justifyContent: "center",
            my: 12,
            px: [
                7,
                10
            ],
            children: this.renderUnsubscribeSection()
        });
    };
    _proto.renderUnsubscribeSection = function renderUnsubscribeSection() {
        var _this = this;
        var _state = this.state, casaAddress = _state.casaAddress, pageType = _state.pageType;
        switch(pageType){
            case "error":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorPage, {
                    casaAddress: casaAddress
                });
            case "success":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuccessPage, {
                    casaAddress: casaAddress
                });
            case "manual":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ManualAddressPage, {
                    addressInput: casaAddress && this.casaAddressToAddressInput(casaAddress),
                    cancelManualAddressVerification: this.cancelManualAddressVerification,
                    modifyAddress: this.submitAddress
                });
            case "verify":
                if (casaAddress) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerifyAddressPage, {
                        casaAddress: casaAddress,
                        googleMapsApiKey: globals/* GOOGLE_MAPS_API_KEY */.eu,
                        toManualAddressVerification: function() {
                            return _this.setState({
                                pageType: "manual"
                            });
                        },
                        unsubscribeAddress: function() {
                            return _this.unsubscribeAddress(casaAddress);
                        }
                    });
                }
                this.setState({
                    pageType: "error"
                });
                return;
            default:
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressEntryPage, {
                    onChooseManualEntry: function() {
                        return _this.setState({
                            pageType: "manual"
                        });
                    },
                    onSubmit: this.submitAddress
                });
        }
    };
    _proto.getCasaAddressData = function getCasaAddressData(data) {
        if (!data.casa || !data.casa.findByFields || !data.casa.findByFields.address) {
            return {};
        }
        var address = data.casa.findByFields.address;
        return {
            addressUuid: address.uuid,
            city: address.city,
            latitude: address.latitude,
            longitude: address.longitude,
            postalCode: address.postalCode,
            state: address.state,
            street: address.street,
            unitNumber: address.unitNumber,
            unitType: address.unitType
        };
    };
    _proto.casaAddressToAddressInput = function casaAddressToAddressInput(address) {
        return {
            city: address.city || "",
            postal_code: address.postalCode || "",
            state: address.state || "",
            street1: address.street || "",
            unit: address.unitNumber || ""
        };
    };
    return UnsubscribePage;
}(react.PureComponent);

;// CONCATENATED MODULE: ./src/pages/mail.tsx




var Mail = function(param) {
    var header = param.header, footer = param.footer;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout/* default */.Z, {
        header: header !== null && header !== void 0 ? header : undefined,
        footer: footer !== null && footer !== void 0 ? footer : undefined,
        slug: "/mail",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnsubscribePage, {})
    });
};
var __N_SSG = true;
/* harmony default export */ var mail = (Mail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5527,6852,6523,9652,6398,2864,4746,7387,2949,7093,8704,1861,5675,7982,3783,5569,7166,6930,9167,245,2804,4991,8268,9872,9774,2888,179], function() { return __webpack_exec__(95821); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);